import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CoreModule } from '@app/core';
import { SharedModule } from '@app/shared';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { MomentModule } from 'ngx-moment';
import { FilterPipeModule } from '@app/shared/filter/filter.module';
import {
  MatTabsModule,
  MatCheckboxModule,
  MatDatepickerModule,
  MatProgressSpinnerModule,
  MatExpansionModule,
  MatSlideToggleModule
} from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SatDatepickerModule, SatNativeDateModule } from 'saturn-datepicker';
import { Angular2PromiseButtonModule } from 'angular2-promise-buttons';
import { DateFnsModule } from 'ngx-date-fns';
import { FeedbackRoutingModule } from './feedback-routing.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { Ng5SliderModule } from 'ng5-slider';
import { Angular2CsvModule } from 'angular2-csv';
import { OverviewComponent } from './overview/overview.component';
import { StatisticComponent } from './statistic/statistic.component';
import { ChartsModule } from 'ng2-charts';
import { StatisticsDetailsComponent } from './statistics-details/statistics-details.component';
import { IntegrationComponent } from './integration/integration.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { GoogleReviewsComponent } from './google-reviews/google-reviews.component';

@NgModule({
  declarations: [
    OverviewComponent,
    StatisticComponent,
    IntegrationComponent,
    StatisticsDetailsComponent,
    GoogleReviewsComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    NgbModule,
    CoreModule,
    SharedModule,
    FeedbackRoutingModule,
    NgScrollbarModule,
    NgxDatatableModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MomentModule,
    FilterPipeModule,
    MatTabsModule,
    Ng5SliderModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    SatDatepickerModule,
    SatNativeDateModule,
    MatDatepickerModule,
    MatExpansionModule,
    MatSlideToggleModule,
    ChartsModule,
    NgSelectModule,
    Angular2PromiseButtonModule.forRoot({
      spinnerTpl: '<span class="fas fa-spinner fa-spin button-loading"></span>'
    }),
    DateFnsModule.forRoot(),
    Angular2CsvModule
  ],
  entryComponents: []
})
export class FeedbackModule {}
